import {DateTime} from 'luxon';

export function fromDatetimeHelper(date: DateTime | null): string | null {
  return date?.toFormat('dd.MM.yyyy HH:mm') ?? null;
}
